import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const IOSDownload: React.FC = () => {
  const [showInstructions, setShowInstructions] = useState(false);
  const { t } = useTranslation()

  const handleDownloadClick = () => {
    setShowInstructions(true);
  };

  return (
    <div className='IOSDownloadBox'>
      <button onClick={handleDownloadClick} className='button'>{t("btnInstall")}</button>
      {showInstructions && (
        <div className="overlay">
          <p>{t("downloadOverlayTitle")}</p>
          <ol>
            <li>{t("downloadOverlayStep1")}</li>
            <li>{t("downloadOverlayStep2")}</li>
          </ol>
          <button onClick={() => setShowInstructions(false)}>{t("back")}</button>
        </div>
      )}
    </div>
  );
};

export default IOSDownload;
